// extracted by mini-css-extract-plugin
export var detailsCaret = "_c6-1";
export var detailsExpanded = "_c6-2";
export var itemDetailsContainer = "_c6-0";